module.exports = __webpack_public_path__ + "static/media/tab-0.e6da1e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/tab-0.png
// module id = 1250
// module chunks = 0